import React from "react";
import { ArrowUpRight, Activity, CheckCircle2 } from "lucide-react";

// Premium floating dashboard preview built from pure UI primitives — no stock image.
export default function DashboardPreview() {
  return (
    <div className="relative w-full" data-testid="dashboard-preview">
      <div className="rounded-2xl border border-slate-200 bg-white shadow-float overflow-hidden">
        {/* topbar */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200/80">
          <div className="flex items-center gap-2">
            <span className="size-2 rounded-full bg-rose-400/80" />
            <span className="size-2 rounded-full bg-amber-400/80" />
            <span className="size-2 rounded-full bg-emerald-400/80" />
            <span className="ml-3 text-[11px] font-mono text-slate-400">connex.is/dashboard</span>
          </div>
          <span className="text-[10px] font-semibold tracking-widest text-slate-400">LIVE</span>
        </div>

        <div className="grid grid-cols-12 gap-3 p-4 bg-slate-50/60">
          {/* KPI strip */}
          <div className="col-span-12 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              { l: "Leads (today)", v: "1,284", d: "+12.4%" },
              { l: "Avg CPL", v: "£42.18", d: "−3.1%" },
              { l: "Accept rate", v: "73.2%", d: "+2.0%" },
              { l: "AI bookings", v: "312", d: "+18%" },
            ].map((k, i) => (
              <div key={i} className="rounded-lg bg-white border border-slate-200 p-3">
                <div className="text-[10px] uppercase tracking-wider text-slate-500">{k.l}</div>
                <div className="mt-1 text-[15px] font-semibold text-slate-900 tabular-nums">{k.v}</div>
                <div className="text-[10px] text-emerald-600">{k.d}</div>
              </div>
            ))}
          </div>

          {/* chart */}
          <div className="col-span-12 sm:col-span-7 rounded-lg bg-white border border-slate-200 p-3">
            <div className="flex items-center justify-between">
              <div className="text-[11px] font-medium text-slate-700">Delivery — last 14d</div>
              <span className="inline-flex items-center gap-1 text-[10px] text-slate-500"><Activity className="size-3" /> live</span>
            </div>
            <svg viewBox="0 0 280 100" className="w-full h-24 mt-2">
              <defs>
                <linearGradient id="ar" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="#0055FF" stopOpacity="0.28" />
                  <stop offset="100%" stopColor="#0055FF" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path d="M0 78 L20 70 L40 74 L60 60 L80 64 L100 50 L120 56 L140 42 L160 48 L180 30 L200 36 L220 22 L240 28 L260 16 L280 22 L280 100 L0 100 Z" fill="url(#ar)" />
              <path d="M0 78 L20 70 L40 74 L60 60 L80 64 L100 50 L120 56 L140 42 L160 48 L180 30 L200 36 L220 22 L240 28 L260 16 L280 22" fill="none" stroke="#0055FF" strokeWidth="1.6" />
            </svg>
          </div>

          {/* live feed */}
          <div className="col-span-12 sm:col-span-5 rounded-lg bg-white border border-slate-200 p-3 min-w-0">
            <div className="text-[11px] font-medium text-slate-700 mb-2">Live lead feed</div>
            <ul className="space-y-2">
              {[
                ["Mortgage", "London", "£38"],
                ["Debt help", "Leeds", "£28"],
                ["Business fin.", "Manchester", "£52"],
                ["Claims", "Bristol", "£42"],
              ].map((r, i) => (
                <li key={i} className="grid grid-cols-[1fr_auto_auto] items-center gap-x-2 text-[11px] min-w-0">
                  <span className="flex items-center gap-1.5 text-slate-700 min-w-0">
                    <span className="size-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0" />
                    <span className="truncate">{r[0]}</span>
                  </span>
                  <span className="text-slate-400 text-[10px] tabular-nums shrink-0">{r[1]}</span>
                  <span className="font-mono text-slate-900 tabular-nums shrink-0 ml-1">{r[2]}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* floating accent card */}
      <div className="absolute -right-6 -bottom-6 hidden md:flex w-[200px] items-center gap-2.5 rounded-xl bg-white border border-slate-200 px-3 py-2.5 shadow-float">
        <span className="grid place-items-center size-8 rounded-full bg-primary/10 text-primary"><CheckCircle2 className="size-4" /></span>
        <div className="leading-tight">
          <div className="text-[11px] font-semibold text-slate-900">Compliance pass</div>
          <div className="text-[10px] text-slate-500">TrustedForm · TCPA · GDPR</div>
        </div>
      </div>

      {/* floating signal card */}
      <div className="absolute -left-4 -top-5 hidden md:flex items-center gap-2 rounded-xl bg-slate-900 text-white px-3 py-2 shadow-float">
        <span className="size-1.5 rounded-full bg-emerald-400 animate-pulse" />
        <span className="text-[10px] tracking-wider uppercase">Routing &nbsp;<span className="text-emerald-300">98.6ms</span></span>
        <ArrowUpRight className="size-3" />
      </div>
    </div>
  );
}
